import ClassifiedList from './ClassifiedList'

export default ClassifiedList
